import React, { useState, useEffect } from "react";
import "./Price.css";

import Title from "../ui/Title/title";
import ProductCard from "../ui/ProductCard/ProductCard";

import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";

function Price({ setProduct }) {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("cakes");

  // Загрузка данных из Firestore при монтировании компонента
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Загрузка продуктов
        const productsSnapshot = await getDocs(collection(db, "products"));
        const productsData = productsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productsData);

        // Загрузка категорий
        const categoriesSnapshot = await getDocs(collection(db, "categories"));
        const categoriesData = categoriesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCategories(categoriesData);
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      }
    };

    fetchData();
  }, []);

  const ProductList = () => {
    const filteredProducts = products.filter(
      (product) => product.category === selectedCategory
    );

    return (
      <div>
        <nav className="menu">
  {categories.map((category) => (
    <a
      key={category.id}
      className={`aa ${selectedCategory === category.slug ? "active" : ""}`}
      href={`#${category.slug}`}
      onClick={() => setSelectedCategory(category.slug)}
      style={
        category.slug === "hit"
          ? {
              background: "linear-gradient(45deg, #ff6b6b, #ff8e53)",
              color: "white",
              padding: "5px 10px",
              borderRadius: "5px",
              fontWeight: "bold",
            }
          : {}
      }
    >
      {category.name}
    </a>
  ))}
</nav>

        <div className="product-list">
          {filteredProducts.map((product) => (
            <ProductCard
              key={product.id}
              name={product.name}
              description={product.description}
              old_price={product.old_price}
              price={product.price}
              image={product.image}
              size={product.size}
              gramm={product.gramm}
              setProduct={setProduct}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="price" id="Price">
      <Title title="Прайс" translate="Price" />
      <div className="price-content">
        <ProductList />
        {(selectedCategory === "medovik" ||
          selectedCategory === "bento-maxi" ||
          selectedCategory === "bento" ||
          selectedCategory === "cakes") && (
          <section className="extras">
            <h2 className="ex-name">Дополнительно</h2>
            <ul>
              <li className="li-name">
                Шоколадный велюр - <strong>500 р.</strong>
              </li>
              <li className="li-name">
                Печать на съедобной бумаге - <strong>от 300 р.</strong>
              </li>
              <li className="li-name">
                Роспись и мазки - <strong>от 100 р.</strong>
              </li>
              <li className="li-name">
                Кремовый рисунок - <strong>от 200 р.</strong>
              </li>
              <li className="li-name">
                Кремовая надпись -{" "}
                <strong
                  style={{
                    color: "#FFC107",
                  }}
                >
                  бесплатно
                </strong>
              </li>
            </ul>
          </section>
        )}
        {/* {selectedCategory === 'hit' && (
          <section className="sets">
            <h2 className="ex-name">Наборы</h2>
            <ul>
              <li className="li-name">Мадлен 6 шт. + 6 шт. конфет <strong>1400 р.</strong></li>
              <li className="li-name">Мадлен 9 шт. + 6 шт. конфет <strong>1700 р.</strong></li>
              <li className="li-name">Мадлен 12 шт. + 6 шт. конфет <strong>2000 р.</strong></li>
              <li className="li-name">Конфеты 6 шт. <strong>800 р.</strong></li>
              <li className="li-name">Конфеты 8 шт. <strong>1100 р.</strong></li>
              <li className="li-name">Конфеты 9 шт. <strong>1200 р.</strong></li>
              <li className="li-name">Конфеты 12 шт. <strong>1600 р.</strong></li>
              <li className="li-name">Конфеты 16 шт. <strong>2200 р.</strong></li>
            </ul>
          </section>
        )} */}
        {selectedCategory === "moti" && (
          <section className="extras">
            <h2 className="ex-name">Дополнительно</h2>
            <ul>
              <li className="li-name">Наличие уточнять</li>
              <li className="li-name">
                Если нужен конкретный вкус - срок изготовления 1-2 дня
              </li>
            </ul>
          </section>
        )}
      </div>
    </div>
  );
}

export default Price;
